import { Navigate } from 'react-router-dom'

import AuthGuard from '../../auth/AuthGuard'
import MatxLayout from '../base/components/Template/MatxLayout/MatxLayout'
import almacenRoutes from '../modules/almacen/almacenRoutes'
import arqueosCajaRoutes from '../modules/arqueoCaja/arqueoCajaRoutes'
import articuloRoutes from '../modules/articulo/articuloRoutes'
import articuloMonedaRoutes from '../modules/ArticuloMoneda/articuloMonedaRoutes'
import articuloPrecioRoutes from '../modules/articuloPrecio/articuloPrecioRoutes'
import cuentaRoutes from '../modules/base/cuenta/CuentaRoutes'
import NotFound from '../modules/base/sessions/NotFound'
import sessionRoutes from '../modules/base/sessions/SessionRoutes'
import cajasRoutes from '../modules/cajas/cajasRoutes'
import clientsRoutes from '../modules/clients/clientsRoutes'
import cuentasRoutes from '../modules/cuentas/cuentasRoutes'
import cuentasCobrarRoutes from '../modules/cuentas_cobrar/cuentasCobrarRoutes'
import deaRoutes from '../modules/destruccionArticulo/deaRoutes.tsx'
import entradaRoutes from '../modules/entrada/entradaRoutes'
import gumRoutes from '../modules/grupoUnidadMedida/gumRoutes.tsx'
import homeRoutes, { homeRoutesMap } from '../modules/home/HomeRoutes'
import kardexRoutes from '../modules/kardex/kardexRoutes'
import kardexPeriodoRoutes from '../modules/kardexPeriodo/kardexPeriodoRoutes'
import loteRoutes from '../modules/lote/loteRoutes'
import metodosDePagoRoutes from '../modules/metodoPago/MetodosDePagoRoutes'
import monedaRoutes from '../modules/moneda/monedaRoutes'
import notasDeProduccionRoutes from '../modules/notasDeProduccion/noDeProRoutes'
import proveedorRoutes from '../modules/proveedor/proveedorRoutes'
import recetasRoutes from '../modules/recetas/recetasRoutes'
import tipoArticuloRoutes from '../modules/tipoArticulo/tipoArticuloRoutes'
import transferenciasRoutes from '../modules/transferencias/transferenciasRoutes'
import turnosRoutes from '../modules/turnos/turnosRoutes'
import unidadMedidaRoutes from '../modules/unidadMedida/unidadMedidaRoutes'

export const appRoutes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...homeRoutes,
      ...cuentaRoutes,
      ...articuloRoutes,
      ...articuloPrecioRoutes,
      ...gumRoutes,
      ...unidadMedidaRoutes,
      ...almacenRoutes,
      ...loteRoutes,
      ...tipoArticuloRoutes,
      ...articuloMonedaRoutes,
      ...kardexPeriodoRoutes,
      ...entradaRoutes,
      ...cuentasRoutes,
      ...proveedorRoutes,
      ...monedaRoutes,
      ...kardexRoutes,
      ...clientsRoutes,
      ...cuentasCobrarRoutes,
      ...recetasRoutes,
      ...notasDeProduccionRoutes,
      ...transferenciasRoutes,
      ...cajasRoutes,
      ...turnosRoutes,
      ...arqueosCajaRoutes,
      ...metodosDePagoRoutes,
      ...deaRoutes,
    ],
  },
  ...sessionRoutes,
  { path: '/', element: <Navigate to={homeRoutesMap.home.path} /> },
  { path: '*', element: <NotFound /> },
]
